<template>
  <SfButtonDs
    variant="ai"
    icon-before="wand-magic-sparkles"
    :disabled="noFiles || exceededMaxFiles"
    @click="emit('analyze')"
  >
    {{ analyzeLabel }}
  </SfButtonDs>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'

import { useOCRDocuments } from '../store/use-ocr-documents'

const I18n = useI18n()

const emit =
  defineEmits<{
    analyze: []
  }>()

const analyzeLabel = I18n.t('ai_ocr_requests.steps.analyze')

const documentStore = useOCRDocuments()
const { exceededMaxFiles, noFiles } = storeToRefs(documentStore)
</script>
